import axios from 'axios'

const baseURL = process.env.REACT_APP_SERVER_ENDPOINT

const service = axios.create({ baseURL, withCredentials: true })

export const updateUserInfo = async (userId, userData) => {
  const user = await service.patch(`/boletines/updateUser/${userId}`, userData)
  return user
}